import React, {Component} from 'react';
import TableCentrifuge from './TableCentrifuge';
import Criterials from '../../general/criterials';
import moment from 'moment';
import swal from 'sweetalert';
import Inputmask from 'inputmask';

var Config = require('../../../../config');

class FormCentrifuge extends Component{
	constructor(props){
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.onProgramSelect = this.onProgramSelect.bind(this);
		this.getData = this.getData.bind(this);
		this.selectAll = this.selectAll.bind(this);
		this.onChecked = this.onChecked.bind(this);
		this.getCentrifugeData = this.getCentrifugeData.bind(this);

		var aux_date = new Date();

		this.state = {
			date_form : aux_date.getFullYear()+'-'+("0" + (aux_date.getMonth() + 1)).slice(-2)+'-'+("0" + aux_date.getDate()).slice(-2),
			hour: "",
			equipments:[],
			equipment_id:"",

			programs:[],
			program_id:"",

			speed:"",
			temperature:"",
			time:"",
			speed_aceleration:"",
			speed_desaceleration:"",

			centrifuges:[],
			donations:[],
			all_check:false,
		}
	}

	componentDidMount(){
		var selector = document.getElementById("hour");
		var im = new Inputmask("--:--");
		im.mask(selector);

		this.props.onRef(this);

		fetch(Config.default.apiGateway.URL+'equipments/by_health_facility?health_facilities_id='+
					sessionStorage.getItem("health_facilities_id")+'&type=centrífuga&active=true', {
			method : 'get',
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
			
		})
		.then(res => res.json())
		.then(response => {
			this.setState({
				equipments: response
			})
		});

		fetch(Config.default.apiGateway.URL+'centrifuges', {
			method : 'get',
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		})
		.then(res => res.json())
		.then(response => {
			this.setState({
				programs: response
			});
		});

		fetch(Config.default.apiGateway.URL+'offers?option=date',{ 
			method: 'get',
			headers: new Headers({
			   'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
			   'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(result) {
                swal('¡Error', result, 'error');
              });
            }})
		.then(response => {
			var aux = response.split('|');
			
			var hours = this.getHourFormat(aux[1]);

			this.setState({
				hour:hours,
			});
		});
	}

	getHourFormat(hr){
		var format = hr.split(' ');
		var hrs    = format[0].split(':');
		var ampm = format.length === 2 ? format[1] : format[1]+' '+format[2];
		var hour = parseInt(hrs[0],10);
		var minute = parseInt(hrs[1],10);
		
		if((ampm === "PM" || ampm === "p. m.") && hour < 12)	hour += 12;

		if((ampm === "AM" || ampm === "a. m.") && hour === 12)	hour -= 12;

		if(hour < 10) hour = '0'+hour;

		if(minute < 10) minute = '0'+minute;
		var nvaHour = hour+':'+minute;

		return nvaHour;
	}

	handleChange(e){
		var campo = e.target.name;

		this.setState({
			[campo] : e.target.value
		});

		if(campo === 'hour'){
			var hour = moment(e.target.value, 'h:mm a');

			if(hour.format('H:mm') === "Invalid date" || e.target.value.indexOf('-') !== -1){
				document.getElementById(e.target.id).classList.add("error");
				document.getElementById(e.target.name).style.borderColor = "red";
			}else{
				document.getElementById(e.target.name).style.borderColor = "#ccc";
				document.getElementById(e.target.id).classList.remove("error");
			}
		
		}else{
			setTimeout(function(){
				this.showCtrlError(campo);
			}.bind(this), 500)
		}	

	}

	getData(result){
		this.setState({centrifuges:result});
		result.map((a)=>{
			return this.setState({
					donations: [...this.state.donations, {
						id: a.id !== "" ? a.id : a.unit.id, 
						check:false
					}]
				})
		});

		setTimeout(function(){
			this.inputRef.focus();
		}.bind(this), 500);
	}

	onProgramSelect(e){
		var name = e.target.value;
		
		this.state.programs.map((p, i)=>{
			return p.centrifuge.name === name?
					this.setState({
						program_id:name,
						equipment_id:p.centrifuge.equipment_id,
						speed:p.centrifuge.speed,
						temperature: p.centrifuge.temperature,
						time:p.centrifuge.time,
						speed_aceleration: p.centrifuge.speed_aceleration,
						speed_desaceleration: p.centrifuge.speed_desaceleration
					})
				: null
		});

		setTimeout(function(){
			const inputs = document.querySelectorAll('select,input');
		   	    
		    inputs.forEach(input => {
	    		var control = document.getElementById(input.name);
	    		if(control !== null && control.value !== ""){
					if(control.required && control.className.includes('error')){
						control.classList.remove('error');
					}
				}	
		    });
		}.bind(this), 500);
			
	}

	onChecked(e){
		this.state.donations.map((u, j)=>{
			if(u.id === parseInt(e.target.id)){
				u.check = u.check ? false : true;	
			}
		});
		this.forceUpdate();
	}

	selectAll(e){
		if(e.target.checked){
			this.setState({
				all_check:true
			})
		}else{
			this.setState({
				all_check:false
			})
		}

		this.state.donations.map((u, j)=>{
			if(e.target.checked)	
				u.check = true;
			else
				u.check = false;	
			
		});
		this.forceUpdate();
	}

	getCentrifugeData(){
		var obj = {};
		var parts = [];
		obj.equipment_id = parseInt(this.state.equipment_id);
		obj.name = this.state.program_id;
		obj.speed = parseInt(this.state.speed);
		obj.temperature = parseInt(this.state.temperature);
		obj.time = parseInt(this.state.time);
		obj.speed_aceleration = parseInt(this.state.speed_aceleration);
		obj.speed_desaceleration = parseInt(this.state.speed_desaceleration);
		//obj.blod_bags_id = parseInt(this.criterials.state.blood_bags_id);
		var date = moment(this.state.date_form.split('-').reverse().join('/'), 'DD-MM-YYYY');
		var hour = moment(this.state.hour, 'h:mm a');

		obj.date = date.format('MM-DD-YYYY');;
		obj.hour = this.state.hour.indexOf('-') !== -1 ? "Invalid date" : hour.format('H:mm');

		this.state.centrifuges.map((c, i)=>{

			return this.state.donations[i].check ?
					this.state.donations[i].id === c.id ?
						c.unit.map((u, j)=>{
							return parts.push({
								unit_id:u.id
							})
						})
					: this.state.donations[i].id === c.unit.id ?
						parts.push({
							unit_id: c.unit.id
						})
					:null
				:null
		});

		obj.centrifuge_parts = parts;

		return obj;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);

		if (this.state[refName] === "") {
			if(control !== null){
				control.classList.add('error');
			}
			res = false;
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}
			res = true;
		}
		

		return res;
	}

	validateInput(e) {
	    const re = /^[-+]?$/;

	    if (e.key === "Enter") {
      		e.preventDefault(); // Prevent form submission if button present
      		
      		const form = e.target.form;
      		const index = Array.prototype.indexOf.call(form, e.target);

      		if(form.elements[index + 1] !== undefined){
      			if(form.elements[index + 1].getAttribute("type") === 'checkbox'){
	               	form.elements[index + 1].focus();
	                form.elements[index + 1].style.boxShadow = "0 0 5px 2px rgb(104, 173, 253)";
	              
	            }else{
	                form.elements[index + 1].focus();
	            }
	              
      		}
    	
		    if (!re.test(e.key)) {
		      	e.preventDefault();
		    }
		}
  	}

	render(){
		return (
			<div className="col-xs-12 form-group">
	                
				<fieldset>
					<legend style={{fontSize:"1.5em"}}>Búsqueda</legend>

					<Criterials {...this.props} validate={this.validateInput} sendData={this.getData} onRef={ref => (this.criterials = ref)} />
					
				</fieldset>


				<fieldset>
					<legend style={{fontSize:"1.5em"}}>Proceso</legend>

					<div className="col-xs-12 col-sm-11 col-md-10" style={{marginLeft:"0.9%", marginTop:"1em"}}>
						<div className="col-xs-12 col-sm-7">
							<div className="row" style={{marginBottom:"5px"}}>
								<div className="col-xs-12 col-sm-4">
									<span>Fecha</span>
								</div>
								<div className="col-xs-12 col-sm-4">
									<input className="form-control" name="date_form" id="date_form" type="date" value={this.state.date_form || ""} 
										onChange={this.handleChange} ref={(input) => { this.inputRef = input }} onKeyPress={(e) => this.validateInput(e)} required />
								</div>

								<div className="col-xs-12 col-sm-1">
									<span>Hora</span>
								</div>
								<div className="col-xs-12 col-sm-3">
									<input id="hour" name="hour" type="text" data-inputmask-alias="datetime" data-inputmask-inputformat="HH:MM"  
										data-inputmask-placeholder="-" value={this.state.hour || ""} onChange={this.handleChange}
										required onKeyPress={(e)=>this.validateInput(e)} className="form-control"/>
								</div>
							</div>

							<div className="row" style={{marginBottom:"5px"}}>
								<div className="col-xs-12 col-sm-4">
									<span>Programa</span>
								</div>
								<div className="col-xs-12 col-sm-8">
									<select className="form-control" name="program_id" id="program_id" value={this.state.program_id || ""}
										onChange={this.onProgramSelect} required onKeyPress={(e) => this.validateInput(e)}>
										<option value="">Seleccione...</option>
										{this.state.programs.map((p, i)=>{
											return <option key={i} value={p.centrifuge.name}>
													{p.lookup_value}
												   </option>	
										})}
									</select>
								</div>
							</div>					
							<div className="row" style={{marginBottom:"5px"}}>
								<div className="col-xs-12 col-sm-4">
									<span>Centrifugado</span>
								</div>
								<div className="col-xs-12 col-sm-8">
									<select className="form-control" name="equipment_id" id="equipment_id" required
										onChange={this.handleChange} value={this.state.equipment_id || ""} onKeyPress={(e) => this.validateInput(e)}>
										<option value="">Seleccione...</option>
										{this.state.equipments.map((type, i) => (
											<option key={i} value={type.id}>{type.name}</option>
										))

										}
									</select>
								</div>						
							</div>
							<div className="row" style={{marginBottom:"5px"}}>
								<div className="col-xs-12 col-sm-4">
									<span>Velocidad</span>
								</div>
								<div className="col-xs-12 col-sm-8">
									<input className="form-control" type="number" value={this.state.speed || ""} 
										onChange={this.handleChange} name="speed" id="speed" onKeyPress={(e) => this.validateInput(e)} required />
								</div>
							</div>
							<div className="row" style={{marginBottom:"5px"}}>
								<div className="col-xs-12 col-sm-4">
									<span>Temperatura</span>
								</div>
								<div className="col-xs-12 col-sm-8">
									<input className="form-control" type="number" value={this.state.temperature || ""} 
										onChange={this.handleChange} name="temperature" onKeyPress={(e) => this.validateInput(e)} id="temperature" required />
								</div>
							</div>
							<div className="row" style={{marginBottom:"5px"}}>
								<div className="col-xs-12 col-sm-4">
									<span>Tiempo</span>
								</div>
								<div className="col-xs-12 col-sm-8">
									<input className="form-control" type="number" value={this.state.time || ""} 
										onChange={this.handleChange} name="time" onKeyPress={(e) => this.validateInput(e)} id="time" required />
								</div>
							</div>
							<div className="row" style={{marginBottom:"5px"}}>
								<div className="col-xs-12 col-sm-4">
									<span>V. Aceleración</span>
								</div>
								<div className="col-xs-12 col-sm-8">
									<input className="form-control" type="number" id="speed_aceleration" value={this.state.speed_aceleration || ""} 
										onChange={this.handleChange} name="speed_aceleration" onKeyPress={(e) => this.validateInput(e)} required />
								</div>
							</div>
							<div className="row" style={{marginBottom:"5px"}}>
								<div className="col-xs-12 col-sm-4">
									<span>V. Desaceleración</span>
								</div>
								<div className="col-xs-12 col-sm-8">
									<input className="form-control" type="number" id="speed_desaceleration" value={this.state.speed_desaceleration || ""}
										onChange={this.handleChange} name="speed_desaceleration" onKeyPress={(e) => this.validateInput(e)} required />
								</div>
							</div>
						</div>
						<div className="col-xs-12 col-sm-5">
							<TableCentrifuge {...this.props} validate={this.validateInput} state={this.state} selectAll={this.selectAll} checked={this.onChecked}
								onRef={ref => (this.table = ref)} />
						</div>
					</div>
				</fieldset>

					
			</div>
				
		)
	}
}

export default FormCentrifuge;
